<template>
  <div class="modal fade" :class="show ? 'show' : 'hide'" style="display: block; background-color: rgba(0,0,0,0.3)">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{title}}</h4>
          <button class="close" type="button" @click="closePopup"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body">
          <p class="m-0">Select a tag that you would like to add.</p>
          <div class="d-flex flex-column justify-content-center align-items-center">
            <el-select v-model="selectedTag" placeholder="Select tag" value-key="label" class="tag-input"
                       @change="selectedTagChange">
              <el-option-group label="Press Tab/Escape to exit">
                <el-option
                    v-for="item in data"
                    :key="item.key"
                    :label="item.label"
                    :value="item">
                </el-option>
              </el-option-group>
            </el-select>
            <div class="d-flex" v-if="selectedTag.key" style="width: 100%;">
              <el-input-number
                  class="tag-input"
                  v-if="selectedTag.type === 'string' && showNumberInput"
                  placeholder="Input data"
                  v-model="tagValue"
                  :controls="false"
                  :min="1"
                  :precision="0"
              />
              <el-input
                  class="tag-input"
                  v-else-if="selectedTag.type === 'string'"
                  placeholder="Input data"
                  v-model="tagValue"
              />
              <el-select v-else class="tag-input" v-model="tagValue" placeholder="Select data">
                <el-option-group label="Press Tab/Escape to exit">
                  <el-option v-for="value in getOptionsForSelectedTag()" :key="value" :label="value"
                             :value="value"></el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" type="button" @click="closePopup">Close</button>
          <button class="btn btn-primary" :class="{disabled: !tagValue}" @click="saveTag" type="button">Add tag</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import studyActions from '../../store/modules/studies/actionTypes'
import studyGetters from '../../store/modules/studies/getterTypes'
import { numberTagInputs } from '../../constants/studyDetails'

export default {
  name: 'AddTagPopup',
  props: {
    data: Array,
    title: String
  },
  data () {
    return {
      show: false,
      selectedTag: {
        key: '',
        label: ''
      },
      tagValue: ''
    }
  },
  computed: {
    ...mapGetters({
      tags: studyGetters.GET_STUDY_DETAILS_TAGS
    }),
    showNumberInput () {
      return this.selectedTag && numberTagInputs.includes(this.selectedTag.label)
    }
  },
  methods: {
    ...mapActions({
      addNewTag: studyActions.POST_TAG_EDIT
    }),
    selectedTagChange () {
      this.tagValue = ''
    },
    showPopup () {
      this.show = true
    },
    closePopup () {
      this.selectedTag = ''
      this.tagValue = ''
      this.show = false
    },
    saveTag () {
      const data = {}
      data[this.selectedTag.key] = this.tagValue
      this.addNewTag({ studyId: this.$route.params.id, data, isNew: true })
      this.selectedTag = ''
      this.tagValue = ''
      this.show = false
    },
    getOptionsForSelectedTag () {
      const selectedTag = this.tags.find(el => el.field === this.selectedTag.key)
      return selectedTag ? selectedTag.options : []
    }
  }
}
</script>

<style scoped>
.hide {
  height: 0;
}

.show {
  height: 100%;
}

.modal-dialog {
  margin-top: 80px;
}

.tag-input {
  margin-top: 10px;
  width: 100%;
}
</style>
